import React, { useState } from "react";
import { FaShieldAlt, FaExchangeAlt, FaCogs, FaMinus, FaPlus, FaChartLine, FaNetworkWired, FaHeadset, FaSync, FaCode, FaServer, FaTools, FaLaptopCode, FaChalkboardTeacher, FaTachometerAlt, FaClock, FaRegCheckCircle, FaUserGraduate, } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const MirthConnect = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">Mirth Connect Implementation & Training</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs, we offer expert implementation and training to help healthcare organizations integrate and optimize their systems efficiently, ensuring secure and standardized data interoperability.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            We provide end-to-end Mirth Connect implementation and training services, enabling healthcare organizations to seamlessly integrate, manage, and exchange healthcare data across systems.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Mirth Connect Implementation",
        description: "Seamless integration of HL7, FHIR, and DICOM data across healthcare systems.",
        icon: FaExchangeAlt
    },
    {
        title: "Custom Interface Development",
        description: "Build tailored Mirth interfaces to meet specific data exchange requirements.",
        icon: FaLaptopCode
    },
    {
        title: "Scalable & Secure Integration",
        description: "Deploy robust, HIPAA-compliant solutions for scalable data interoperability.",
        icon: FaServer
    },
    {
        title: "Mirth Connect Training",
        description: "Hands-on training programs to empower teams in configuring and troubleshooting Mirth interfaces.",
        icon: FaTools
    },
    {
        title: "Compliance & Security Audits",
        description: "Ensure secure and compliant healthcare data exchange with expert-led audits.",
        icon: FaShieldAlt
    }
];


const services = [

    {
        title: "Mirth Connect Installation & Configuration",
        description: "Deploy and configure Mirth Connect servers for optimized performance.",
        icon: FaServer
    },
    {
        title: "HL7, FHIR & DICOM Integration",
        description: "Implement Mirth interfaces to support healthcare data exchange using HL7, FHIR, CCD, and DICOM.",
        icon: FaExchangeAlt
    },
    {
        title: "Custom Interface Development",
        description: "Design custom message transformation and routing logic using Mirth Connect’s scripting engine.",
        icon: FaCode
    },
    {
        title: "Real-Time Data Processing",
        description: "Ensure automated data exchange between EHRs, LIS, RIS, PACS, and other healthcare systems.",
        icon: FaClock
    },
    {
        title: "Security & Compliance Optimization",
        description: "Implement HIPAA-compliant encryption, access controls, and audit logging.",
        icon: FaShieldAlt
    },
    {
        title: "Performance Tuning & Troubleshooting",
        description: "Optimize channel performance and resolve issues for high-efficiency workflows.",
        icon: FaTachometerAlt
    },
    {
        title: "Mirth Connect Training & Workshops",
        description: "Provide hands-on training for IT teams, developers, and healthcare professionals.",
        icon: FaChalkboardTeacher
    },
    {
        title: "Automated Workflow Management",
        description: "Streamline healthcare processes by automating workflows and reducing manual interventions.",
        icon: FaSync
    },
    {
        title: "Custom Dashboard & Analytics",
        description: "Develop interactive dashboards to monitor data flow, errors, and performance metrics in real-time.",
        icon: FaChartLine
    },
    // {
    //     title: "Scalable Cloud Integration",
    //     description: "Deploy Mirth Connect on cloud platforms for enhanced flexibility, security, and scalability.",
    //     icon: FaCogs
    // }
];
const whyChooseUs = [
    {
        title: "Expert Implementation",
        description: "Years of experience in Mirth Connect-based integrations for hospitals, clinics, and healthcare providers.",
        icon: FaCogs
    },
    {
        title: "Comprehensive Training",
        description: "Instructor-led sessions covering Mirth scripting, channel development, and advanced troubleshooting.",
        icon: FaUserGraduate
    },
    {
        title: "End-to-End Support",
        description: "From initial setup to ongoing maintenance, we ensure your system runs smoothly and securely.",
        icon: FaTools
    },
    {
        title: "Custom Solutions",
        description: "Tailored Mirth-based integration for EHRs, laboratories, pharmacies, and imaging centers.",
        icon: FaRegCheckCircle
    },
    {
        title: "Regulatory Compliance",
        description: "Ensure HL7, HIPAA, FHIR, and ONC compliance for secure and standardized data exchange.",
        icon: FaTachometerAlt
    },
    {
        title: "Performance Optimization",
        description: "Fine-tune Mirth Connect interfaces for high-speed processing and scalable data exchange.",
        icon: FaNetworkWired
    },
    {
        title: "Seamless Multi-System Integration",
        description: "Connect effortlessly with EHRs, LIS, PACS, RIS, and third-party healthcare systems.",
        icon: FaNetworkWired
    },
    {
        title: "24/7 Monitoring & Support",
        description: "Get real-time system monitoring, proactive troubleshooting, and fast issue resolution.",
        icon: FaHeadset
    }
];


const List = [

    {
        "title": "Mirth Connect Deployment & Optimization",
        "description": "Expert deployment and configuration of Mirth Connect servers to ensure efficient, high-performance healthcare data integration. We optimize server settings, manage scalability, and streamline workflows for seamless interoperability across EHRs, labs, and healthcare applications.",
        "icon": "FaServer"
    },
    {
        "title": "Custom HL7 & FHIR Interfaces",
        "description": "Develop and fine-tune HL7, FHIR, and DICOM-based interfaces in Mirth Connect for seamless data exchange between healthcare systems. Our tailored solutions ensure interoperability, compliance, and efficient communication between providers, payers, and diagnostic platforms.",
        "icon": "FaExchangeAlt"
    },
    {
        "title": "Mirth Connect Training Programs",
        "description": "Comprehensive hands-on workshops covering Mirth Connect channel development, scripting, troubleshooting, and performance tuning. Learn best practices in interface customization, data transformation, and secure data exchange to maximize Mirth Connect's capabilities.",
        "icon": "FaChalkboardTeacher"
    },
    {
        "title": "Security & Compliance Audits",
        "description": "Ensure robust data security, encryption, and regulatory compliance with industry standards such as HIPAA, HL7, and FHIR. We conduct thorough audits to identify vulnerabilities, implement security best practices, and protect sensitive healthcare data from breaches and cyber threats.",
        "icon": "FaShieldAlt"
    },
    {
        "title": "Ongoing Support & Maintenance",
        "description": "Benefit from 24/7 monitoring, proactive troubleshooting, and continuous performance optimization for Mirth Connect environments. Our dedicated support team ensures system reliability, prevents downtime, and keeps your integrations running smoothly with timely updates and security patches.",
        "icon": "FaLifeRing"
    }
]




export default MirthConnect;
